module.exports = __webpack_public_path__ + "static/img/2ban.b4b773b3.png";